import { isArrayBuffer, isArrayBufferView, isBlob, isBuffer, isFile, isFormData, isURLSearchParams, isHeaders, } from '../../helper';
const CONTENT_TYPE_KEY = 'content-type';
const setContentTypeIfUnset = (headers, value) => {
    if (isHeaders(headers)) {
        if (!headers.has(CONTENT_TYPE_KEY)) {
            headers.append(CONTENT_TYPE_KEY, value);
        }
    }
    else if (!headers[CONTENT_TYPE_KEY]) {
        headers[CONTENT_TYPE_KEY] = value;
    }
};
const optionsParser = function (ctx, next) {
    const { req } = ctx;
    if (!req.method) {
        req.method = 'GET';
    }
    else {
        req.method = req.method.toUpperCase();
    }
    if (!req.headers) {
        req.headers = {};
    }
    const { method } = req;
    const body = req.data || req.body;
    if (method !== 'GET') {
        switch (true) {
            case isFormData(body):
                req.body = body;
                break;
            case isBlob(body):
            case isFile(body):
            case isBuffer(body):
            case isArrayBuffer(body):
            case isArrayBufferView(body):
            case isURLSearchParams(body):
                setContentTypeIfUnset(req.headers, 'multipart/form-data');
                req.body = body;
                break;
            default:
                // application/x-www-form-urlencoded
                setContentTypeIfUnset(req.headers, 'application/json');
                req.body = JSON.stringify(body);
                break;
        }
    }
    if (req.withCredentials === undefined) {
        req.withCredentials = true;
    }
    if (req.credentials === undefined) {
        req.credentials = 'same-origin';
    }
    return next();
};
export default optionsParser;
//# sourceMappingURL=optionsParser.js.map